import { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useNavigationPaths } from '../propertyAssociation/useNavigationPaths';
import { useAsset } from './assetService';
import { DEFAULTS_EMPTY, DefaultsLookup } from './assetTypes/assetTypes';
import AssetOverview from './steps/AssetOverview';

const ViewAsset: FunctionComponent = () => {
    const paths = useNavigationPaths();
    const navigate = useNavigate();
    const { id } = useParams() as any;
    const { asset, refetch } = useAsset(id);
    const [defaults, setDefaults] = useState(DEFAULTS_EMPTY);

    useEffect(() => {
        if (asset) {
            const newDefaults = DefaultsLookup[asset.assetType.tag];
            setDefaults(newDefaults ?? DEFAULTS_EMPTY);
        }
    }, [asset]);

    const gotoAssets = () => {
        navigate(paths.assets);
    };

    const setIsInEditMode = (editMode: boolean) => {
        if (editMode) {
            navigate(paths.editAsset(id));
        }
    };

    const updateValues = () => {
        refetch();
    };

    if (!asset || !defaults) {
        return null;
    }

    const actions = {
        setIsInEditMode,
        updateValues,
    };

    return (
        <div className="app__inner app__inner--paper paper">
            <div className="paper__header">
                <h1 className="paper__heading">{asset.name}</h1>
                <button className="paper__close" onClick={gotoAssets}>
                    Stäng
                </button>
            </div>

            <AssetOverview defaults={defaults} asset={asset} {...actions} />
        </div>
    );
};

export default ViewAsset;
